import React from "react";
import DataSourceCard from "../DataSourceCard/DataSourceCard";
import ServiceTitanIcon from "../ServiceTitanIcon/ServiceTitanIcon";
import ServiceTitanConfiguration from "../ServiceTitanConfiguration/ServiceTitanConfiguration";

interface ServiceTitanDataSourceProps {
  companyUuid: string;
  isConfigured: boolean;
  isExpanded: boolean;
  onToggle: () => void;
}

const ServiceTitanDataSource: React.FC<ServiceTitanDataSourceProps> = ({
  companyUuid,
  isConfigured,
  isExpanded,
  onToggle,
}) => {
  return (
    <DataSourceCard
      capabilities={[
        { label: "Operational KPIs", isActive: isConfigured },
        { label: "Customer leads", isActive: isConfigured },
      ]}
      id="servicetitan"
      isConnected={isConfigured}
      isExpanded={isExpanded}
      logo={
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-indigo-500">
          <ServiceTitanIcon className="h-5 w-5 text-white" />
        </span>
      }
      name="ServiceTitan"
      onToggle={onToggle}
    >
      <ServiceTitanConfiguration companyUuid={companyUuid} />
    </DataSourceCard>
  );
};

export default ServiceTitanDataSource;
